// 公寓子应用
import Apartment from "@/views/apartment/Apartment";

const routes = [
    {
        path: "/Apartment",
        name: "Apartment",
        meta: {
            title: "公寓公租房"
        },
        component: Apartment
    },
];
export default routes;
